const filtersDictionary = {
    "city": [{ru: "город", lv: "pilsēta", en: "city"}, {type: 'queryParam', queryParam: 'type=104'}],
    "county": [{ru: "область", lv: "novads", en: "county"}, {type: 'queryParam', queryParam: 'type=113'}],
    "parish": [{ru: "округ", lv: "pagasts", en: "parish"}, {type: 'queryParam', queryParam: 'type=105'}],
    "village": [{ru: "деревня", lv: "ciems", en: "village"}, {type: 'queryParam', queryParam: 'type=106'}],
    "limit": [{ru: "лимит", lv: "limits", en: "limit"}, {type: 'queryParamWithInput', queryParam: 'limit', value: 20}],
    "lks_lat": [{ru: "lks lat", lv: "lks lat", en: "lks lat"}, {type: 'queryParamWithInput', instant: true, queryParam: 'lks_lat', value: ""}],
    "lks_long": [{ru: "lks long", lv: "lks long", en: "lks long"}, {type: 'queryParamWithInput', queryParam: 'lks_long', value: ""}]
}

const parseFilters = (filters) => {
    const finalFilters = [];
    for (const filterKeyOrArray of filters) {
        if (typeof filterKeyOrArray === "string" && filtersDictionary.hasOwnProperty(filterKeyOrArray)) {
            finalFilters.push(filtersDictionary[filterKeyOrArray]);
        } else if (Array.isArray(filterKeyOrArray)) {
            if (typeof filterKeyOrArray[0] === "object" &&
                filterKeyOrArray[0].ru &&
                filterKeyOrArray[0].en &&
                filterKeyOrArray[0].lv &&
                typeof filterKeyOrArray[1] === "object"
            ) {
                if (filterKeyOrArray[1].type && filterKeyOrArray[1].queryParam) {
                    finalFilters.push(filterKeyOrArray);
                }
            } else {
                console.warn("Filter is not defined correctly, check your code")
            }
        }
    }

    return finalFilters;
}

export default parseFilters;